import { render } from "./create_tag_category.html?vue&type=template&id=5c5eac08&external"
import script from "./create_tag_category.js?vue&type=script&lang=js&external"
export * from "./create_tag_category.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__